const alphabet = '0123456789abcdef';
const encodeLookup = [];
const decodeLookup = [];
for (let i = 0; i < 256; i++) {
  encodeLookup[i] = alphabet[i >> 4 & 0xf] + alphabet[i & 0xf];
  if (i < 16) {
    if (i < 10) {
      decodeLookup[0x30 + i] = i;
    } else {
      decodeLookup[0x61 - 10 + i] = i;
    }
  }
}
export function encodeHex(array) {
  const length = array.length;
  let string = '';
  let i = 0;
  while (i < length) {
    string += encodeLookup[array[i++]];
  }
  return string;
}
export function decodeHex(string) {
  const sizeof = string.length >> 1;
  const length = sizeof << 1;
  const array = new Uint8Array(sizeof);
  let n = 0;
  let i = 0;
  while (i < length) {
    array[n++] = decodeLookup[string.charCodeAt(i++)] << 4 | decodeLookup[string.charCodeAt(i++)];
  }
  return array;
}
//# sourceMappingURL=hex-transcoder.js.map